import { LeadForm } from "@modules/lead/components";
import { BlogUpdate } from "@modules/study/home";
import API from "@unisearch/helpers/api";
import { useEffect, useRef, useState } from "react";
import styles from "./../events.module.scss";
import EventAbout from "./about";
import AttendUniversity from "./attend_university";
import EventDirection from "./direction";
import EventHero from "./hero";
import EventTopics from "./topics";
import EventWhyAttent from "./why_attend";

export const USAAdmissionDay = () => {
  const [formData, setFormData] = useState();
  const bookNowRef = useRef(null);
  const viewLocationRef = useRef(null);
  const goToBookNow = () => {
    bookNowRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const goToviewLocation = () => {
    viewLocationRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const fetchData = async () => {
    const res = await API.get(
      `public/lead-contact-form/schema/usa-admission-day`
    );
    if (res && !res.error) {
      setFormData(res.data);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <EventHero
        goToBookNow={goToBookNow}
        goToviewLocation={goToviewLocation}
      />
      <EventAbout
        goToBookNow={goToBookNow}
        goToviewLocation={goToviewLocation}
      />
      <EventWhyAttent
        goToBookNow={goToBookNow}
        goToviewLocation={goToviewLocation}
      />
      <EventTopics />
      <AttendUniversity />
      <div ref={viewLocationRef}>
        <EventDirection />
      </div>
      <section>
        <div className="container">
          <div ref={bookNowRef}>
            <div className={styles.form_wrapper}>
              <LeadForm
                formTitle={"Sign Up for the UniSearch <br/> USA Admission Day"}
                formSubTitle={
                  "Interested in exploring your options to study abroad? Share your details with us below, and we will be in touch with you shortly!"
                }
                showTitle={false}
                showSubTitle={false}
                onlyFormData={formData}
                buttonTitle="Submit"
                pageSlug={"usa-admission-day"}
              />
            </div>
          </div>
        </div>
      </section>
      <BlogUpdate query="usa" />
    </>
  );
};

export default USAAdmissionDay;
